import { render, staticRenderFns } from "./VoteQuestion.vue?vue&type=template&id=5a9f09f3"
import script from "./VoteQuestion.vue?vue&type=script&lang=js"
export * from "./VoteQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports